import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { ReactiveFormsModule } from '@angular/forms';
import {
  CancelComponent,
  FeedbackSurveyComponent,
  LayoutDefaultComponent,
} from '@shared/components';
import { ButtonModule } from '@vg-constellation/angular-16/button';
import {
  VgimCommonModule,
  VgimPersonalAddressModule,
  VgimPersonalPhoneModule,
} from 'vg-interaction-model';

import { ContactInfoRoutingModule } from './contact-info-routing.module';
import { ContactInfoComponent } from './containers/contact-info.component';

@NgModule({
  imports: [
    ButtonModule,
    CommonModule,
    ContactInfoRoutingModule,
    ReactiveFormsModule,
    VgimPersonalAddressModule.forRoot({
      environment: 'production',
      application: 'COO',
    }),
    VgimCommonModule.forRoot({
      environment: 'production',
      application: 'COO',
    }),
    ReactiveFormsModule,
    CancelComponent,
    FeedbackSurveyComponent,
    LayoutDefaultComponent,
    VgimPersonalPhoneModule.forRoot({
      environment: 'production',
      application: 'COO',
    }),
  ],
  declarations: [ContactInfoComponent],
  exports: [ContactInfoComponent],
})
export class ContactInfoModule {}
